class AuthService {
  constructor () {
    this.obj = {
      token: `${process.env.VUE_APP_NAME}_token`,
      user: `${process.env.VUE_APP_NAME}_user`,
    }
    this.token = window.localStorage.getItem(this.obj.token)
    this.profile = window.localStorage.getItem(this.obj.user)
  }

  check () {
    return !!this.token
  }

  token () {
    return !!this.token
  }

  user () {
    return JSON.parse(window.localStorage.getItem(this.obj.user)) || {};
  }
  role () {
    return this.user()?.user?.role?.short_name || '';
  }
  //check if is gamer
  isAGamer() {
    return this.role() === 'GAMER';
  }
  logout() {
    window.localStorage.clear();
    window.location.href = "/auth/sign-in";
  }

  login ({ token, developer }) {
    window.localStorage.setItem(this.obj.token, token)
    window.localStorage.setItem(this.obj.user, JSON.stringify(developer))
    this.token = token
    this.user = developer
  }

  setUser (user) {
    window.localStorage.removeItem(this.obj.user)
    window.localStorage.setItem(this.obj.user, JSON.stringify(user))
    this.user = user
    location.reload()
  }
}

export default new AuthService()
